import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Flex,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { CTAPresentationProps } from '../types';
import { SectionAnchor } from '../../../shared/components';

const CTAPresentation: React.FC<CTAPresentationProps> = ({
  id
}) => {
  const bgGradient = useColorModeValue(
    'linear(to-r, brand.primary.dark, brand.secondary.base)',
    'linear(to-r, brand.primary.dark, brand.secondary.base)'
  );

  return (
    <>
      <SectionAnchor id={id} />
      <Box as="section" pt={{ base: 4, md: 6 }} pb={{ base: 8, md: 12 }}>
      <Container maxW="container.xl">
        <Box
          borderRadius="xl"
          overflow="hidden"
          bgGradient={bgGradient}
          py={{ base: 10, md: 16 }}
          px={{ base: 6, md: 10 }}
          position="relative"
          boxShadow="xl"
        >
          <Box
            position="absolute"
            top="-50px"
            right="-50px"
            width="200px"
            height="200px"
            borderRadius="full"
            bg="rgba(255, 255, 255, 0.1)"
            zIndex={0}
          />
          
          <Flex
            direction={{ base: 'column', md: 'row' }}
            align="center"
            justify="space-between"
            position="relative"
            zIndex={1}
            gap={{ base: 8, md: 0 }}
          >
            <Stack spacing={4} maxW={{ md: '60%' }}>
              <Heading
                as="h2"
                size="xl"
                color="white"
                lineHeight="1.2"
              >
                Ready to Transform Your Organization?
              </Heading>
              <Text fontSize="lg" color="whiteAlpha.900">
                Schedule a consultation with our team to explore how agentic systems 
                can optimize your operations and drive innovation.
              </Text>
            </Stack>
            
            <Stack 
              direction={{ base: 'column', sm: 'row' }} 
              spacing={4}
            >
              <Button
                size="lg"
                bg="white"
                color="brand.primary.dark"
                _hover={{
                  bg: 'gray.100',
                }}
                as="a"
                href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2c6vLHYel5sfK0HgYvFV4AwAFt5rI6buw9kUzeqDn9FcB9l0QKIMRuP7GvG3AhMmU_C-uBUpwi"
                target="_blank"
                rel="noopener noreferrer"
              >
                Schedule Consultation
              </Button>
              <Button
                size="lg"
                variant="outline"
                color="white"
                borderColor="white"
                _hover={{
                  bg: 'whiteAlpha.200',
                }}
                as="a"
                href="#solutions"
              >
                Explore Solutions
              </Button>
            </Stack>
          </Flex>
        </Box>
      </Container>
    </Box>
    </>
  );
};

export default CTAPresentation;